import React, { useEffect, useRef, useState } from "react";
import {
  SearchContainer,
  SearchIconContainer,
  SearchBox,
  SearchInput,
  CloseWrapper,
} from "./search.styles";
import { useMediaQuery } from "../../../utils/utils.common";
import { CloseIcon, SearchIcon } from "../../icons";

interface ButtonGroupProps {
  fieldBorder: string;
  fieldBackground: string;
  fieldPlaceholderText: string;
  textBody: string;
  brandTertiary: string;
  brandPrimary: string;
  openSearch: boolean;
  setOpenSearch: (s: boolean) => void;
  setSearchTerm: (term: string) => void;
  disableAnimation?: boolean;
  expandInContainer?: boolean;
}

const Search: React.FC<ButtonGroupProps> = ({
  fieldBorder,
  fieldBackground,
  fieldPlaceholderText,
  textBody,
  brandTertiary,
  brandPrimary,
  openSearch,
  setOpenSearch,
  setSearchTerm,
  disableAnimation = false,
  expandInContainer = false,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [localSearch, setLocalSearch] = useState("");

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [isFocused]);

  const openSearchHandler = () => {
    setOpenSearch(true);
    setIsFocused(true);
  };

  const closeSearchHandler = () => {
    setOpenSearch(false);
    setSearchTerm("");
    setLocalSearch("");
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalSearch(value);
    setSearchTerm(value);
  };

  return (
    <SearchContainer expandInContainer={expandInContainer}>
      <SearchIconContainer
        onClick={openSearchHandler}
        brandTertiary={brandTertiary}
      >
        <SearchIcon size={isMobile ? "small" : "large"} />
      </SearchIconContainer>
      <SearchBox
        open={openSearch}
        isFocused={isFocused}
        disableAnimation={disableAnimation}
        expandInContainer={expandInContainer}
        fieldBorder={fieldBorder}
        fieldBackground={fieldBackground}
        textBody={textBody}
        fieldPlaceholderText={fieldPlaceholderText}
        brandPrimary={brandPrimary}
      >
        <SearchIcon size="middle" />
        <SearchInput
          ref={inputRef}
          placeholder="Start Searching"
          onFocus={() => setIsFocused(true)}
          fieldPlaceholderText={fieldPlaceholderText}
          textBody={textBody}
          fieldBackground={fieldBackground}
          value={localSearch}
          onChange={handleInputChange}
        />
        <CloseWrapper onClick={closeSearchHandler}>
          <CloseIcon size="small" />
        </CloseWrapper>
      </SearchBox>
    </SearchContainer>
  );
};

export default Search;
